(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function formatArticleRegisteredMarks() {
    document.querySelectorAll('.xo-main-article__content').forEach((content) => {
      const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.textContent.includes('®') && !node.parentElement.closest('sup, script, style')) nodes.push(node);
      }
      nodes.forEach((node) => {
        const fragment = document.createDocumentFragment();
        node.textContent.split('®').forEach((part, index) => {
          if (index) {
            const mark = document.createElement('sup');
            mark.textContent = '®';
            mark.style.cssText = 'font-size:0.4em;line-height:0;position:relative;top:-0.9em;vertical-align:baseline';
            fragment.append(mark);
          }
          fragment.append(document.createTextNode(part));
        });
        node.replaceWith(fragment);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatArticleRegisteredMarks, { once: true });
  } else {
    formatArticleRegisteredMarks();
  }
  document.addEventListener('shopify:section:load', formatArticleRegisteredMarks);

  } catch(e) { console.error(e); }
})();
})();
